import React from 'react';
import { render, screen } from '@testing-library/react';
import ProgressBar from './ProgressBar';

describe('ProgressBar', () => {
  it('renders the correct number of segments', () => {
    const { container } = render(<ProgressBar currentStep={2} totalSteps={5} />);
    const segments = container.querySelectorAll('[aria-hidden="true"]');
    expect(segments).toHaveLength(5);
  });

  it('marks active segments with context class', () => {
    const { container } = render(<ProgressBar currentStep={3} totalSteps={5} context="talent" />);
    const segments = container.querySelectorAll('[aria-hidden="true"]');
    expect(segments[0]).toHaveClass('talent');
    expect(segments[1]).toHaveClass('talent');
    expect(segments[2]).toHaveClass('talent');
    expect(segments[3]).toHaveClass('inactive');
    expect(segments[4]).toHaveClass('inactive');
  });

  it('defaults to neutral context', () => {
    const { container } = render(<ProgressBar currentStep={1} totalSteps={2} />);
    const segments = container.querySelectorAll('[aria-hidden="true"]');
    expect(segments[0]).toHaveClass('neutral');
  });

  it('applies custom className', () => {
    const { container } = render(<ProgressBar currentStep={1} totalSteps={3} className="custom" />);
    expect(container.firstChild).toHaveClass('custom');
  });

  describe('clamping', () => {
    it('clamps currentStep to 0 when negative', () => {
      const { container } = render(<ProgressBar currentStep={-1} totalSteps={3} />);
      const progressbar = screen.getByRole('progressbar');
      expect(progressbar).toHaveAttribute('aria-valuenow', '0');
      const segments = container.querySelectorAll('[aria-hidden="true"]');
      segments.forEach(s => expect(s).toHaveClass('inactive'));
    });

    it('clamps currentStep to totalSteps when exceeding', () => {
      render(<ProgressBar currentStep={10} totalSteps={3} />);
      expect(screen.getByRole('progressbar')).toHaveAttribute('aria-valuenow', '3');
    });
  });

  describe('accessibility', () => {
    it('has role="progressbar"', () => {
      render(<ProgressBar currentStep={1} totalSteps={3} />);
      expect(screen.getByRole('progressbar')).toBeInTheDocument();
    });

    it('has aria-valuenow', () => {
      render(<ProgressBar currentStep={2} totalSteps={5} />);
      expect(screen.getByRole('progressbar')).toHaveAttribute('aria-valuenow', '2');
    });

    it('has aria-valuemin and aria-valuemax', () => {
      render(<ProgressBar currentStep={1} totalSteps={4} />);
      const progressbar = screen.getByRole('progressbar');
      expect(progressbar).toHaveAttribute('aria-valuemin', '0');
      expect(progressbar).toHaveAttribute('aria-valuemax', '4');
    });

    it('has default aria-label', () => {
      render(<ProgressBar currentStep={1} totalSteps={3} />);
      expect(screen.getByRole('progressbar')).toHaveAttribute('aria-label', 'Progress');
    });

    it('supports custom aria-label', () => {
      render(<ProgressBar currentStep={2} totalSteps={4} label="Application progress" />);
      expect(screen.getByRole('progressbar')).toHaveAttribute('aria-label', 'Application progress');
    });

    it('hides individual segments from screen readers', () => {
      const { container } = render(<ProgressBar currentStep={1} totalSteps={3} />);
      const segments = container.querySelectorAll('[aria-hidden="true"]');
      expect(segments).toHaveLength(3);
    });
  });
});
